import {styled, Toolbar} from "@mui/material"
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { Colors } from "../theme";

export const StyledToolbar =  styled(Toolbar)(()=>({
    display:"flex",
    justifyContent:"space-between"
}))



export const NavbarContainer = styled(Box)(()=>({
    display:"flex",
    marginTop:4,
    justifyContent:"center",
    alignItems:"center",
    padding:"2px 8px"
}))

export const NavbarHeader = styled(Typography)(()=>({
    padding:"4px",
    flexGrow:1,
    fontSize:"1.5em",
    fontFamily:'"Montez","cursive"',
    color:Colors.secondary,
}))

export const Search = styled("div")(({theme})=>({
    backgroundColor:"whitesmoke",
    padding:"0px 10px",
    borderRadius:theme.shape.borderRadius,
    width:"40%"
}))


